import { useState } from "react";
import { ArrowDown, ArrowUp, GripVertical } from "lucide-react";

export const moveItem = (arr, from, to) => {
  if (to < 0 || to >= arr.length || from === to) return arr;
  const a = [...arr];
  const [x] = a.splice(from, 1);
  a.splice(to, 0, x);
  return a;
};

export const SortableList = ({ items, onChange, render, getKey = (it, i) => it?.id ?? i, testid = "sortable", className = "space-y-2", handleOnly = false }) => {
  const [drag, setDrag] = useState(null);
  const [over, setOver] = useState(null);
  const [armed, setArmed] = useState(null);

  return (
    <div className={className} data-testid={testid}>
      {items.map((it, i) => (
        <div
          key={getKey(it, i)}
          draggable={!handleOnly || armed === i}
          onDragStart={(e) => { setDrag(i); e.dataTransfer.effectAllowed = "move"; e.dataTransfer.setData("text/plain", String(i)); }}
          onDragOver={(e) => { e.preventDefault(); setOver(i); }}
          onDragLeave={() => setOver(null)}
          onDrop={(e) => { e.preventDefault(); if (drag !== null) onChange(moveItem(items, drag, i)); setDrag(null); setOver(null); }}
          onDragEnd={() => { setDrag(null); setOver(null); setArmed(null); }}
          className={`flex items-center gap-2 bg-white border rounded-md p-2 transition-colors ${over === i && drag !== i ? "border-crimson bg-red-50" : "border-stone-200"} ${drag === i ? "opacity-50" : ""}`}
          data-testid={`${testid}-item-${i}`}
        >
          <span onMouseDown={() => setArmed(i)} onMouseUp={() => setArmed(null)} className="self-start pt-1 cursor-grab shrink-0" data-testid={`${testid}-handle-${i}`}><GripVertical className="w-4 h-4 text-stone-400" /></span>
          <div className="flex-1 min-w-0">{render(it, i)}</div>
          <div className="flex flex-col shrink-0">
            <button type="button" disabled={i === 0} onClick={() => onChange(moveItem(items, i, i - 1))} className="p-0.5 text-stone-500 hover:text-crimson disabled:opacity-25" data-testid={`${testid}-up-${i}`} aria-label="Move up"><ArrowUp className="w-4 h-4" /></button>
            <button type="button" disabled={i === items.length - 1} onClick={() => onChange(moveItem(items, i, i + 1))} className="p-0.5 text-stone-500 hover:text-crimson disabled:opacity-25" data-testid={`${testid}-down-${i}`} aria-label="Move down"><ArrowDown className="w-4 h-4" /></button>
          </div>
        </div>
      ))}
    </div>
  );
};
